import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth, useTheme } from '../../global-components/src';
import { useNotifications } from '../../hooks/UseNotifications';
import Nav from "../../global-components/src/components/navbar-mobile/navbar-mobile";
import { getAppVersion, getNativeNavigationHeight, isIOSWebView, isNewApp, isNewAppAndroid } from '../../utils/platform';
import { NotificationBadge, NotificationChatBadge } from '../../hooks/notifications';
import { useFeed } from '../../contexts/FeedContext';
import "./style.css"
import { useAddPost } from '../../contexts/AddPostContext';
import { HeartIcon, HomeIcon, MessageSquareIcon, PlusIcon, SearchIcon, UserIcon } from 'lucide-animated';
import AnimatedMenuIcon from '../animated-menu-icon';

type Position = 'absolute' | 'relative' | 'fixed' | 'sticky' | 'static';
interface NavbarMobileProps {
    position?: Position
}

const NavbarMobile: React.FC<NavbarMobileProps> = ({ position }) => {
    const location = useLocation();
    const path = location.pathname;
    const { isAuthenticated, user } = useAuth();
    const [bottomPadding, setBottomPadding] = useState(5);
    const appVersion = getAppVersion();
    const { isDarkMode, isNewUI, isNewPacoca, isLiquidGlass } = useTheme();
    const { setPage, setEnd, setFeedType, feedType, setPosts } = useFeed();
    const navigate = useNavigate();
    const { setOpen: setOpenPost } = useAddPost();
    
    useEffect(() => {
        if(isNewApp() && appVersion && appVersion <= 94){
            function ajustaMenu() {
                const alturaTela = window.innerHeight;
                const alturaTotal = window.screen.height;
                const diferenca = alturaTotal - alturaTela;
    
                setBottomPadding(diferenca == 1 ? 45 : 25);
            }
            
            ajustaMenu();
            window.addEventListener("resize", ajustaMenu);
            return () => window.removeEventListener("resize", ajustaMenu);
        }
    }, []);

    useEffect(() => {
        if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
            function ajustaNewApp() {
                const nativeNavigationHeight = getNativeNavigationHeight();

                if(nativeNavigationHeight && nativeNavigationHeight > 0){
                    setBottomPadding(nativeNavigationHeight);
                }
            }
            
            ajustaNewApp()
            window.addEventListener("navigationBarHeightChange", ajustaNewApp);
            return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
        }
    }, []);

    const resetHome = () => {
        if(path != "/"){
            navigate("/");
            return;
        }
        setPage(-1);
    }

    return (
        <div>
            <Nav hideAccount={isLiquidGlass} bottomPadding={bottomPadding}>
                {isAuthenticated ? (
                    <>
                        {/* HOME */}
                        <span className={`nav-link ${path === "/" ? 'active' : ''}`}>
                            <Link aria-label="abrir menu" className="nav-link" to="/" onClick={resetHome}>
                                <AnimatedMenuIcon
                                    Icon={HomeIcon}
                                    active={path === '/'}
                                    className={`icon-menu-dark ${path === '/' ? 'active' : ''}`}
                                    size={30}
                                />
                            </Link>
                            {/* <Link aria-label="abrir menu" className="nav-link" to="/">
                                <Home className={`icon-menu-dark ${path === "/" ? 'active' : ''}`} />
                            </Link> */}
                        </span>

                        {/* PESQUISA */}
                        {!isNewPacoca ? (
                            <span className={`nav-link hide-liquid-glass ${path === "/pesquisa" ? 'active' : ''}`}>
                                <Link className="nav-link" to="/pesquisa" aria-label="Ir para tela de pesquisa">
                                    <AnimatedMenuIcon
                                        Icon={SearchIcon}
                                        active={path === '/pesquisa'}
                                        className={`icon-menu-dark ${path === '/pesquisa' ? 'active' : ''}`}
                                        size={30}
                                    />
                                </Link>
                            </span>
                        ): null}

                        
                        {/* CRIAR POST */}
                        {isNewUI ? (
                            <span className={`anav-item-add-new-pacoca nav-item hide-liquid-glass`}>
                                {/* <span className="nav-link" data-bs-toggle="modal" data-bs-target="#modal-post"> */}
                                <span className="nav-link" onClick={() => setOpenPost(true)}>
                                    <AnimatedMenuIcon Icon={PlusIcon} className="icon-menu-dark" size={30} />
                                </span>
                            </span>
                        ): null}

                        {/* CHAT */}
                        <span className="nav-item">
                            <Link className={`nav-link position-relative ${path === "/chats" ? 'active' : ''}`} to="/chats" aria-label="Ir para tela de pesquisa">
                                <AnimatedMenuIcon
                                    Icon={MessageSquareIcon}
                                    active={path === '/chats'}
                                    className={`icon-menu-dark ${path === '/chats' ? 'active' : ''}`}
                                    size={30}
                                />
                                {/* <MessageSquare className={`icon-menu-dark icon-notification ${path === "/chats" ? 'active' : ''}`} /> */}
                                {window.innerWidth <= 850 && <NotificationChatBadge />}
                            </Link> 
                           
                            {/* <Link aria-label="Ir para chats" className="nav-link position-relative" to="/chats">
                                <MessageSquare className={`icon-menu-dark icon-notification ${path === "/chats" ? 'active' : ''}`} />
                                {window.innerWidth <= 850 && <NotificationChatBadge />}
                            </Link> */}
                        </span> 
                        
                        {/* CRIAR POST */}
                        {!isNewUI ? (
                            <span className={`nav-item hide-liquid-glass`}>
                                {/* <span className="nav-link" data-bs-toggle="modal" data-bs-target="#modal-post"> */}
                                <span className="nav-link" onClick={() => setOpenPost(true)}>
                                    <AnimatedMenuIcon Icon={PlusIcon} className="icon-menu-dark" size={30} />
                                </span>
                            </span>
                        ): null}

                        {/* NOTIFICAÇÕES */}
                        <span className="nav-item">
                            <Link aria-label="Ir para notificações" className={`nav-link position-relative ${path === "/notificacoes" ? 'active' : ''}`} to="/notificacoes">
                                <AnimatedMenuIcon
                                    Icon={HeartIcon}
                                    active={path === '/notificacoes'}
                                    className={`icon-menu-dark ${path === '/notificacoes' ? 'active' : ''}`}
                                    size={30}
                                />
                               
                                {window.innerWidth <= 850 && <NotificationBadge />}
                            </Link>
                        </span>

                        {isLiquidGlass ? (
                            <span className={`nav-item`}>
                                <Link to={`/@${user?.user_name}`} className="nav-link">
                                    <AnimatedMenuIcon Icon={UserIcon} className="icon-menu-dark" size={32} />
                                </Link>
                            </span>
                        ): null}
                    </>
                ) : null}
            </Nav>
        </div>
    );
};

export const AddLighdGlass = () => {
    const { setOpen: setOpenPost } = useAddPost();
    const { isDarkMode, isNewUI, hideMenuMobile } = useTheme();
    const path = location.pathname;
    const [bottomPadding, setBottomPadding] = useState(5);
    const appVersion = getAppVersion();

    useEffect(() => {
        if(isNewApp() && appVersion && appVersion <= 94){
            function ajustaMenu() {
                const alturaTela = window.innerHeight;
                const alturaTotal = window.screen.height;
                const diferenca = alturaTotal - alturaTela;
    
                setBottomPadding(diferenca == 1 ? 45 : 25);
            }
            
            ajustaMenu();
            window.addEventListener("resize", ajustaMenu);
            return () => window.removeEventListener("resize", ajustaMenu);
        }
    }, []);

    useEffect(() => {
        if(!hideMenuMobile) return;
        let lastScrollY = window.scrollY;

        const handleScroll = () => {
            const menu = document.querySelector('.nav-search-liquid-glass') as HTMLElement;
            if (!menu) return;

            if (window.innerWidth <= 850) {
                if (window.scrollY > lastScrollY) {
                    menu.classList.add("hidden-bottom-menu");
                } else {
                    menu.classList.remove("hidden-bottom-menu");
                }
            }
            lastScrollY = window.scrollY;
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [path]);

    useEffect(() => {
        if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
            function ajustaNewApp() {
                const nativeNavigationHeight = getNativeNavigationHeight();

                if(nativeNavigationHeight && nativeNavigationHeight > 0){
                    setBottomPadding(nativeNavigationHeight);
                }
            }
            
            ajustaNewApp()
            window.addEventListener("navigationBarHeightChange", ajustaNewApp);
            return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
        }
    }, []);

    return (
        <span className={`liquid-glass nav-search-liquid-glass nav-item`}style={{ bottom: bottomPadding + 10 }} onClick={setOpenPost}>
                <Link to={`#`} className="nav-link">
                    <AnimatedMenuIcon Icon={PlusIcon} className="icon-menu-dark" size={32} />
                </Link>
        </span>
        // <div className="nav-search-liquid-glass" style={{ bottom: bottomPadding + 13 }} onClick={setOpenPost}>
        //     <span className="nav-item">
        //         <Link className="nav-link" to="/pesquisa" aria-label="Ir para tela de pesquisa">
        //             <Icon invertColor={!isDarkMode} active={path === "/pesquisa" } alt="Ir para home" size={30} name="add">
        //                 <Plus className={`icon-menu-dark ${path === "/" ? 'active' : ''}`} />
        //             </Icon>
        //         </Link>
        //     </span>
        // </div>
    )
}

export default NavbarMobile;
